import React, { useId, useEffect, useRef, useState } from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";
import styles from "./Tooltip.module.scss";

const Tooltip = ({
  data = "",
  children,
  id,
  maxWidth = "250px",
  place = "top",
  force = false,
  tooltipBackground = "#6570fc",
}) => {
  const generatedId = useId();
  const tooltipId = id || generatedId;
  const textRef = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    const el = textRef.current;
    if (el && el.scrollWidth > el.clientWidth) {
      setIsOverflowing(true);
    } else {
      setIsOverflowing(false);
    }
  }, [data]);

  return (
    <>
      <span
        ref={textRef}
        className={styles.truncated}
        data-tooltip-id={force || isOverflowing ? tooltipId : undefined}
        data-tooltip-content={force || isOverflowing ? data : undefined}
        style={{ cursor: "pointer" }}
      >
        {children || data}
      </span>

      {(force || isOverflowing) && (
        <ReactTooltip
          id={tooltipId}
          className={styles.tooltip}
          place={place}
          style={{
            position: "fixed",
            zIndex: 11,
            maxWidth,
            background: tooltipBackground,
          }}
        />
      )}
    </>
  );
};

export default Tooltip;
